module.exports = "/_next/static/images/lufthansa-1756b39680f2a0fe9675a96b4ca33344.svg";